import { useContext } from 'react';

import { PetitionStatsContext } from '#src/app/pages/petitionDetails/shared/contexts';
import type {
	PetitionStats,
	PetitionStatsErrorReason,
	PetitionStatsState,
} from '#src/app/pages/petitionDetails/shared/types';

export type { PetitionStats, PetitionStatsErrorReason, PetitionStatsState };

export function usePetitionStats(): PetitionStatsState {
	const context = useContext(PetitionStatsContext);

	if (!context) {
		throw new Error('PetitionStatsContext was not set');
	}

	return context;
}
